import { VAlert } from 'vuetify/lib/components/VAlert';
import { VApp } from 'vuetify/lib/components/VApp';
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VMain } from 'vuetify/lib/components/VMain';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VApp,[_c(VAppBar,{attrs:{"app":"","color":"#4DBA87","dark":"","flat":""}},[_c('h2',[_vm._v("OmniWeather")])]),_c(VMain,[_c(VContainer,[_c(VRow,{staticClass:"d-flex justify-center"},[(_vm.isOffline)?_c(VCol,{attrs:{"cols":"11","md":"10"}},[_c(VAlert,{attrs:{"type":"error","dismissible":""}},[_vm._v(" Vous êtes hors ligne, veuillez vous connecter au réseau et rafraîchir la page. ")])],1):_vm._e()],1),(_vm.currentLocation)?_c(VRow,{staticClass:"d-flex justify-center"},[_c(VCol,{attrs:{"cols":"12","lg":"6"}},[_c('CurrentWeatherCard')],1)],1):_vm._e()],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }